module.exports = __webpack_public_path__ + "img/block-a-1.c1e22109.png";